import { GET, omsBaseUrlApi } from '@constants/generic-constants';
import NetworkManager from '../../services/network-service';

export const getChatSessionToken = (storeId) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/stores/${storeId}/chat_token`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getChatUrlForLineItem = (lineItemId) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/line_items/${lineItemId}/chat_url`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const getReturnOrderChatUrl = (lineItemId) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/return_line_items/${lineItemId}/chat_url`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
